/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@emotion/react';

/** Attributes for <a/> tags that will open a new tab. Usage: <a {...externalLinkAttributes} />  */
export const externalLinkAttributes = {
	// https://stackoverflow.com/a/15551842/5648839
	target: "_blank",
	rel: "noopener noreferrer"
}

/** An <a/> tag that will open href in a new tab */
export interface ExternalLinkProps extends React.ComponentProps<'a'> { }
export const ExternalLink: React.FC<ExternalLinkProps> = ({ ...props }) => {
	return (
		<a {...externalLinkAttributes} {...props} />
	);
};
